<template>
  <main class="w-full flex-grow p-6">
    <BackButton />
    <div class="flex justify-between items-center">
      <div class="">
        <h1 class="text-3xl font-bold text-app-default">Promo/Detail</h1>
      </div>
      <div class="mr-10" v-if="this.$route.params.id === this.deployedPromoId">
        <span class="text-2xl text-dark font-bold">
          Selected
        </span>
      </div>
      <div class="mr-10" v-else>
        <button
          class="block px-3 h-9 hover:text-white focus:ring focus:ring-primary-default focus:ring-opacity-30 focus:outline-none rounded-md text-2xl bg-app-default hover:bg-app-light text-white font-bold"
          type="button"
          @click="updateDeployedPromo(this.$route.params.id)"
        >
          Select
        </button>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Carousel (1200 px X 500 px)</div>
          </div>
          <div class="flex">
            <img
              class="w-full lg:w-1/2 mr-3 h-44 lg:h-80"
              :src="dataPromo.promotion_carousel"
              alt="23paskal"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Products (1020 px X 1020 px)</div>
          </div>
          <div class="flex">
            <img
              :key="promo"
              class="w-40 h-40 mr-3"
              :src="dataPromo.promotion_images"
              alt="23paskal"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">Promo Info</div>
          </div>
          <div class="font-semibold">Tenant</div>
          <div
            v-if="
              dataPromo?.tenant?.tenant_name !== '' ||
                dataPromo?.tenant?.tenant_name !== undefined
            "
            class="ml-5"
          >
            <router-link
              :to="'/tenant/' + tenant_id"
              class="bg-app-default border-2 p-2 text-white font-bold rounded-md"
            >
              {{ dataPromo?.tenant?.tenant_name }}
            </router-link>
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Name</div>
          <div v-if="dataPromo.promotion_name !== ''" class="ml-5">
            {{ dataPromo.promotion_name }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Description</div>
          <div v-if="dataPromo.promotion_description !== ''" class="ml-5">
            {{ dataPromo.promotion_description }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Category</div>
          <div v-if="dataPromo.promotion_category_name !== ''" class="ml-5">
            {{ dataPromo.promotion_category_name }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Status</div>
          <div v-if="dataPromo.is_active" class="ml-5">Active</div>
          <div v-else class="ml-5">Non Active</div>
          <div class="font-semibold">Promo Start</div>
          <div v-if="dataPromo.promotion_start !== null" class="ml-5">
            {{ promotion_start }}
          </div>
          <div v-else class="ml-5">-</div>
          <div class="font-semibold">Promo End</div>
          <div v-if="dataPromo.promotion_end !== null" class="ml-5">
            {{ promotion_end }}
          </div>
          <div v-else class="ml-5">-</div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import API from "../../api";
import BackButton from "../../components/BackButton.vue";
export default {
  name: "ContentDetail",
  components: {
    BackButton,
  },
  data() {
    return {
      dataPromo: {},
      tenant_id: null,
      deployedPromoId: null,
      promotion_start: "",
      promotion_end: "",
    };
  },
  methods: {
    detailPromo: async function() {
      try {
        let res = await fetch(`${API}v1/admin/cms/promotion/${this.$route.params.id}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("Data not found");
          this.$router.go(-1);
          return;
        }
        this.dataPromo = respon.data;
        this.tenant_id = respon.data.tenant_id;
        let stE = new Date(respon.data.promotion_start);
        let enE = new Date(respon.data.promotion_end);
        this.promotion_start = `${stE.getDate()}-${stE.getMonth() +
          1}-${stE.getFullYear()} ${stE.getHours()}:${stE.getMinutes()}`;
        this.promotion_end = `${enE.getDate()}-${enE.getMonth() +
          1}-${enE.getFullYear()} ${enE.getHours()}:${enE.getMinutes()}`;
      } catch (err) {
        this._error("internal server error");
        this.$router.go(-1);
        return;
      }
    },
    updateDeployedPromo: async function(id) {
      let formdata = new FormData();
      formdata.append("id", id);
      try {
        let res = await fetch(`${API}v1/admin/cms/promotion/displayed_promo/update`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("Data not found");
          this.$router.go(-1);
          return;
        }
        this.deployedPromoId = this.$route.params.id;
      } catch (err) {
        this._error("Internal server error");
        this.$router.go(-1);
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
  },
  created() {
    this.detailPromo();
    this.deployedPromoId = this.$route.query.deployedPromoId;
  },
};
</script>
